import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'

export default function ForbiddenPage() {
  return (
    <>
      <MetaTags
        title="Ingen adgang (403) - Trine Rosendal"
        description="Du har desværre ikke adgang til denne ressource."
      />

      <div className="mx-auto max-w-3xl px-6 py-20 sm:py-28 text-center space-y-6">
        <div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-[#E2EBD9] text-[#5C7A4F] text-2xl font-serif">
          403
        </div>

        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium text-[#222E1D]">
          Adgang ikke tilladt
        </h1>

        <p className="mx-auto max-w-md text-sm sm:text-base text-[#4D5E46] leading-relaxed">
          Du har ikke adgang til at se denne side eller ressource. Du kan benytte navigationen nedenfor til at komme tilbage til de offentligt tilgængelige sider.
        </p>

        <div className="pt-4 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full bg-[#5C7A4F] px-6 py-3 text-sm font-medium text-white shadow-xs hover:bg-[#455C3A] transition"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Tilbage til forsiden</span>
          </Link>

          <Link
            to="/behandlinger"
            className="inline-flex items-center gap-2 rounded-full border border-[#D6E2CB] bg-[#F7F9F3] px-6 py-3 text-sm font-medium text-[#222E1D] hover:bg-[#EAF1E4] transition"
          >
            <span>Se behandlinger</span>
          </Link>

          <Link
            to="/kontakt"
            className="inline-flex items-center gap-2 rounded-full border border-[#D6E2CB] bg-[#F7F9F3] px-6 py-3 text-sm font-medium text-[#222E1D] hover:bg-[#EAF1E4] transition"
          >
            <span>Kontakt Trine</span>
          </Link>
        </div>
      </div>
    </>
  )
}
